export default {"src":"/_next/static/media/event-calender.1d609480.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};